import { Box, styled } from "@mui/material";

export const WellnessPlanPaymentMethodStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "1.5rem 1rem",
  backgroundColor: theme.palette.taupe.dark,
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
}));

export const UpsellContainerStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
  padding: "1rem",
  alignItems: "center",
  alignSelf: "stretch",
  borderRadius: "0.75rem",
  backgroundColor: theme.palette.white.main,
  boxShadow: "2px 2px 18px 0px rgba(55, 54, 23, 0.10)",
}));
